import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the easySplitSettlements state domain
 */

const selectEasySplitSettlementsDomain = state =>
  state.easySplitSettlements || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by EasySplitSettlements
 */

const makeSelectEasySplitSettlements = () =>
  createSelector(
    selectEasySplitSettlementsDomain,
    substate => substate,
  );

export default makeSelectEasySplitSettlements;
export { selectEasySplitSettlementsDomain };
